import { trackingAllowed } from 'src/utils/cookieConsent';

type DataLayerPayload = Record<string, unknown> & { event: string };

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

export const pushDataLayerEvent = (event: string, payload: Record<string, unknown> = {}) => {
  if (typeof window === 'undefined') return;
  if (!trackingAllowed()) return;

  if (!Array.isArray(window.dataLayer)) {
    window.dataLayer = [];
  }

  const eventPayload: DataLayerPayload = {
    event,
    ...payload,
  };

  window.dataLayer.push(eventPayload);
};
